import { useState, useEffect } from "react";
import { Button, Dropdown, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useTranslate } from "../hooks/LanguageProvider";
import CreateTicketModal from "../components/Ticket/Modals/CreateTicket";
import { formatToTimestamp } from "../utilities/functions";
import PropagateLoader from "react-spinners/PropagateLoader";
import { toast, Bounce } from "react-toastify";
import UpdateTicketModal from "../components/Ticket/Modals/UpdateTicket";
import "../assets/css/ticketing.css";
import { usePagePreferences } from "../hooks/usePagePreferences";

interface TicketProps {
  id_ticket: number;
  description: string;
  title: string;
  id_user: number;
  nom_user: string;
  creation_date: string;
  priority: number;
  status: number;
  criticality: number;
  id_category: number;
  id_subcategory: number;
  category_name: string;
  subcategory_name: string;
  first_name: string;
  last_name: string;
}

interface SelectedColumns {
  id_ticket: boolean;
  id_agent: boolean;
  description: boolean;
  category: boolean;
  subcategory: boolean;
  title: boolean;
  id_user: boolean;
  creation_date: boolean;
  priority: boolean;
  status: boolean;
  criticality: boolean;
}

interface ColumnItem {
  key: keyof SelectedColumns;
  label: string;
}

export function Ticket() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { translate } = useTranslate();
  const id_user = localStorage.getItem("userid");
  const {
    preferences: listPreferences,
    setPreference: setListPreference,
    setPreferences: setListPreferences,
    loaded: listPreferencesLoaded,
  } = usePagePreferences("tickets", {
    limit: 10,
    page: 1,
    colum: "id_ticket",
    sort: "DESC",
    search: "",
    type: 0,
    typeSearch: translate("Ticket") + " ID",
  });
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(Number(listPreferences.limit) || 10);
  const [page, setPage] = useState<number>(Number(listPreferences.page) || 1);
  const [list_Ticket, setTickets] = useState<TicketProps[]>([]);
  const [colum, setSortColum] = useState(String(listPreferences.colum || "id_ticket"));
  const [sort, setSort] = useState(String(listPreferences.sort || "DESC"));
  const [search, setSearch] = useState(String(listPreferences.search || ""));
  const [type, setType] = useState(Number(listPreferences.type) || 0);
  const [typeSearch, setTypeSearch] = useState(String(listPreferences.typeSearch || translate("Ticket") + " ID"));
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [showCreateTicketModal, setShowCreateTicketModal] = useState(false);
  const handleShowCreateTicketModal = () => setShowCreateTicketModal(true);
  const handleCloseCreateTicketModal = () => setShowCreateTicketModal(false);
  const [idTicket, setIdTicket,] = useState(0);


  const [showUpdateTicketModal, setShowUpdateTicketModal] = useState(false);
  const [idTicketToUpdate, setIdTicketToUpdate] = useState(0);


  const handleOpenUpdateModal = (id: any) => {
    setIdTicketToUpdate(id);
    setShowUpdateTicketModal(true);
  };

  const handleCloseUpdateTicketModal = () => {
    setShowUpdateTicketModal(false);
    setIdTicketToUpdate(0);
  };



  const handleCreateTicket = async (id_alarme: number, IdUser: string) => {
    try {
      // console.log(id_alarme);
      setIdTicket(id_alarme);
    } catch (error) {
      console.error(error);
    }
  };

  const getTicket = async (
    limit: number,
    page: number,
    search: string,
    type: number,
    colum: string,
    sort: string
  ) => {
    try {
      setLoading(true);
      setErrorMessage("");

      // Preparing the data to send
      const bodyData = JSON.stringify({
        limit,
        page,
        search,
        type,
        id_user: parseInt(id_user || "0"),
        colum: Columns[colum],
        sort,
      });

      // Retrieve the total number of pages
      const totalPagesResponse = await fetch(
        `${backendUrl}/api/ticket/totalpage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: bodyData,
          mode: "cors",
        }
      );

      if (!totalPagesResponse.ok) {
        throw new Error(translate("Unable to load tickets"));
      }
      const totalPagesJson = await totalPagesResponse.json();
      const total = totalPagesJson[0]["count"];
      setTotal(total);

      // Retrieving alarm data
      const ticketsResponse = await fetch(
        `${backendUrl}/api/ticket/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });

      if (!ticketsResponse.ok) {
        throw new Error(translate("Unable to load tickets"));
      }
      const data = await ticketsResponse.json();
      setPageCount(Math.ceil(total / limit));
      setLimit(limit);
      setTickets(data);
      return data;
    } catch (error) {
      console.error(error);
      setErrorMessage(error instanceof Error ? error.message : translate("Unable to load tickets"));
      setTickets([]);
    } finally {
      setLoading(false);
    }
  };


  const refreshTickets = () => {
    getTicket(limit, page, search, type, colum, sort);
  };

  const handlePageClick = async (data: any) => {
    const nextPage = data.selected + 1;
    const commentsFormServer = await getTicket(limit, nextPage, search, type, colum, sort);
    setTickets(commentsFormServer);
    setPage(nextPage);
    setListPreference("page", nextPage);
    window.scrollTo(0, 0);
  };

  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    const nextLimit = parseInt(newValue, 10);
    setPage(1);
    setLimit(nextLimit);
    setListPreferences({ limit: nextLimit, page: 1 });
    const commentsFormServer = await getTicket(
      nextLimit,
      1,
      search,
      type,
      colum,
      sort
    );
    setTickets(commentsFormServer);
    window.scrollTo(0, 0);
  };

  const handleSortingColum = (currentColumn: string) => {
    const nextSort = sort === "ASC" ? "DESC" : "ASC";
    setSortColum(currentColumn);
    setSort(nextSort);
    setPage(1)
    setListPreferences({ colum: currentColumn, sort: nextSort, page: 1 });
    getTicket(limit, 1, search, type, currentColumn, nextSort);
  };


  useEffect(() => {
    if (!listPreferencesLoaded) return;

    const nextLimit = Number(listPreferences.limit) || 10;
    const nextPage = Number(listPreferences.page) || 1;
    const nextSearch = String(listPreferences.search || "");
    const nextType = Number(listPreferences.type) || 0;
    const nextTypeSearch = String(listPreferences.typeSearch || translate("Ticket") + " ID");
    const nextColumn = String(listPreferences.colum || "id_ticket");
    const nextSort = String(listPreferences.sort || "DESC");

    setLimit(nextLimit);
    setPage(nextPage);
    setSearch(nextSearch);
    setType(nextType);
    setTypeSearch(nextTypeSearch);
    setSortColum(nextColumn);
    setSort(nextSort);
    getTicket(nextLimit, nextPage, nextSearch, nextType, nextColumn, nextSort);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listPreferencesLoaded, listPreferences]);

  const [selectedColumns, setSelectedColumns] = useState({
    id_ticket: true,
    id_agent: true,
    description: false,
    category: true,
    subcategory: true,
    title: true,
    id_user: true,
    creation_date: true,
    priority: true,
    status: true,
    criticality: true,
  });

  const Columns: { [key: string]: number } = {
    "id_ticket": 0,
    "agent": 1,
    "description": 2,
    "id_category": 3,
    "id_subcategory": 4,
    "title": 5,
    "id_user": 6,
    "creation_date": 7,
    "priority": 8,
    "status": 9,
    "criticality": 10,
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleColumnChange = (column: string) => {
    setSelectedColumns((prevState: any) => ({
      ...prevState,
      [column]: !prevState[column],
    }));
  };

  const handleTypeSearch = (selectedValue: string) => {

    let nextType = type;
    switch (selectedValue) {
      case translate("Ticket") + " ID":
        nextType = 0;
        setType(nextType);
        break;
      case translate("Agent"):
        nextType = 1;
        setType(nextType);
        break;
      case translate("Description"):
        nextType = 2;
        setType(nextType);
        break;
      case translate("Category"):
        nextType = 3;
        setType(nextType);
        break;
      case translate("Sub category"):
        nextType = 4;
        setType(nextType);
        break;

      case translate("Titre"):
        nextType = 5;
        setType(nextType);
        break;

      case translate("User"):
        nextType = 6;
        setType(nextType);
        break;

      case translate("Status"):
        nextType = 7;
        setType(nextType);
        break;

      case translate("Priority"):
        nextType = 8;
        setType(nextType);
        break;

      case translate("Criticality"):
        nextType = 9;
        setType(nextType);
        break;

      default:
        // console.log("Unknown selection");
        break;
    }

    setTypeSearch(selectedValue);
    setListPreferences({ type: nextType, typeSearch: selectedValue, page: 1 });
    // console.log("Selected value:", selectedValue);
  };


  const handleAdvancedSearch = async (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);
    setPage(1);
    setListPreferences({ search: newValue, page: 1 });
    await getTicket(limit, 1, newValue, type, colum, sort);
  };

  const handleResetSearch = async () => {
    setSearch("")
    setPage(1);
    setListPreferences({ search: "", page: 1 });

    await getTicket(limit, 1, "", type, colum, sort)
  };

  const menuItems = [
    translate("Ticket ID"),
    translate("Agent"),
    translate("Description"),
    translate("Category"),
    translate("Sub category"),
    translate("Titre"),
    translate("Status"),
    translate("Priority"),
    translate("Criticality")
  ];


  const displayColumns: ColumnItem[] = [
    { key: "id_ticket", label: translate("Ticket") + " ID" },
    { key: "title", label: translate("Title") },
    { key: "description", label: translate("Description") },
    { key: "id_user", label: translate("User") },
    { key: "category", label: translate("Category") },
    { key: "subcategory", label: translate("Sub category") },
    { key: "creation_date", label: translate("Creation date") },
    { key: "status", label: translate("Status") },
    { key: "priority", label: translate("Priority") },
    { key: "criticality", label: translate("Criticality") },
  ];

  const getStatusClass = (statusValue: number) => {
    if (statusValue === 1) return "ticket-badge ticket-badge-open";
    if (statusValue === 2) return "ticket-badge ticket-badge-progress";
    if (statusValue === 3) return "ticket-badge ticket-badge-closed";
    return "ticket-badge ticket-badge-muted";
  };

  const getPriorityClass = (priorityValue: number) => {
    if (priorityValue <= 2) return "ticket-badge ticket-badge-high";
    if (priorityValue === 3) return "ticket-badge ticket-badge-medium";
    return "ticket-badge ticket-badge-low";
  };

  const getCriticalityClass = (criticalityValue: number) => {
    if (criticalityValue <= 2) return "ticket-badge ticket-badge-high";
    if (criticalityValue === 3) return "ticket-badge ticket-badge-medium";
    return "ticket-badge ticket-badge-low";
  };



  return (
    <>
      <div className="ticketing-page">
      <div className="ticketing-header">
        <div>
          <h4 className="ticketing-title">
            <i
              className="las la-ticket-alt"
              data-rel="bootstrap-tooltip"
              title="Ticket"
            ></i>{" "}
            {translate("Tickets")}
          </h4>
          <span className="ticketing-subtitle">{total} {translate("Tickets")}</span>
        </div>
        <div className="ticketing-actions">
          <Button
            variant="primary"
            className="ticketing-create-btn"
            onClick={handleShowCreateTicketModal}
          >
            <i className="las la-plus"></i>{translate("Create Ticket")}
          </Button>
        </div>
      </div>
      <div className="ticketing-toolbar">
        <div className="ticketing-search">
          <div className="input-group ticketing-search-group">
            <Dropdown>
              <Dropdown.Toggle variant="light" id="dropdown-basic" className="ticketing-filter-btn">
                <i
                  className="fas fa-chevron-down"
                ></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {menuItems.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => handleTypeSearch(item)}
                    eventKey={item}
                    active={typeSearch === item}
                    className={typeSearch === item ? "select-active" : ""}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <input type="text" value={search} placeholder={` ${translate("Search by")} ${translate(typeSearch)}`} onChange={handleAdvancedSearch} className="form-control" />
            <Button
              variant="secondary"
              onClick={handleResetSearch}
              className="btn-reset"
            >
              <i className="las la-times" style={{ color: "#fff" }}></i>
            </Button>
          </div>
        </div>
        <div className="ticketing-controls">
          <div className="dataTables_length" id="DataTables_Table_0_length">
            <label style={{ marginBottom: "0" }}>
              {translate("Show")}
              <select
                name="DataTables_Table_0_length"
                aria-controls="DataTables_Table_0"
                className="custom-select custom-select-sm form-control form-control-sm ml-2"
                style={{ width: "66px" }}
                value={limit}
                onChange={handleSelectChange}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </select>
            </label>
          </div>
          <Dropdown>
            <Dropdown.Toggle variant="" id="dropdown-basic" title={translate("Display columns")}>
              <i className="las la-list-ol"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {displayColumns.map((column) => (
                <Dropdown.Item
                  key={column.key}
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns[column.key]}
                    onChange={() => handleColumnChange(column.key)}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate(column.label)}
                  </span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <button type="button" onClick={handleShow} className="ticketing-icon-button" title={translate("Filter")}>
            <i className="las la-filter"></i>
          </button>

        </div>
      </div>
      {errorMessage && (
        <div className="alert alert-danger ticketing-alert" role="alert">
          {errorMessage}
        </div>
      )}
      <div className="table-responsive ticketing-table-wrap">
        <Table className="dataTable">
          <thead className=" text-uppercase">
            <tr className="ligth ligth-data">
              <th>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="checkbox" />
                  <label className="form-check-label"></label>
                </div>
              </th>
              {selectedColumns.id_ticket && (<th className="sorting" onClick={() => handleSortingColum("id_ticket")} >{"N° " + translate("Ticket")}</th>)}
              {selectedColumns.title && <th className="sorting" onClick={() => handleSortingColum("title")} >{translate("Title")}</th>}
              {selectedColumns.description && <th className="sorting" onClick={() => handleSortingColum("Description")} >{translate("Description")}</th>}
              {selectedColumns.id_agent && <th className="sorting" onClick={() => handleSortingColum("agent")} >{translate("Agent")}</th>}
              {selectedColumns.category && <th className="sorting" onClick={() => handleSortingColum("category")} >{translate("Category")}</th>}
              {selectedColumns.subcategory && (<th className="sorting" onClick={() => handleSortingColum("subcategory")} >{translate("Sub category")}</th>)}
              {selectedColumns.creation_date && (<th className="sorting" onClick={() => handleSortingColum("creation_date")} >{translate("Creation Date")}</th>)}
              {selectedColumns.id_user && <th className="sorting" onClick={() => handleSortingColum("User")} >{translate("User")}</th>}
              {selectedColumns.status && <th className="sorting" onClick={() => handleSortingColum("status")} >{translate("Status")}</th>}
              {selectedColumns.criticality && (<th className="sorting" onClick={() => handleSortingColum("criticality")}>{translate("Criticality")}</th>)}
              {selectedColumns.priority && (<th className="sorting" onClick={() => handleSortingColum("priority")}>{translate("Priority")}</th>)}

              {<th>{translate("Actions")}</th>}
            </tr>
          </thead>
          <tbody key="#" className="ligth-body">
            {loading ? (
              <tr>
                <td className="text-center" colSpan={11}>
                  <p>
                    <PropagateLoader
                      color={"#123abc"}
                      loading={loading}
                      size={20}
                    /></p>
                </td>
              </tr>
            ) : list_Ticket.length > 0 ? (
              list_Ticket.map((ticket) => (
                <tr key={ticket.id_ticket}>
                  <td>
                    <div className="form-check form-check-inline">
                      <input type="checkbox" className="form-check-input" />
                    </div>
                  </td>
                  {selectedColumns.id_ticket && <td>{ticket.id_ticket}</td>}
                  {selectedColumns.title && <td>{ticket.title}</td>}
                  {selectedColumns.description && <td>{ticket.description}</td>}
                  {selectedColumns.id_agent && <td>{ticket.first_name !== null ? ticket.first_name + " " + ticket.last_name : translate("None")}</td>}
                  {selectedColumns.category && <td>{translate(ticket.category_name)}</td>}
                  {selectedColumns.subcategory && <td>{translate(ticket.subcategory_name)}</td>}
                  {selectedColumns.creation_date && (<td>{formatToTimestamp(ticket.creation_date)}</td>)}
                  {selectedColumns.id_user && <td>{ticket.nom_user}</td>}
                  {selectedColumns.status && <td><span className={getStatusClass(ticket.status)}>{translate(ticket.status.toString())}</span></td>}
                  {selectedColumns.criticality && <td><span className={getCriticalityClass(ticket.criticality)}>{translate(ticket.criticality.toString())}</span></td>}
                  {selectedColumns.priority && <td><span className={getPriorityClass(ticket.priority)}>{translate(ticket.priority.toString())}</span></td>}
                  <td>
                    <div className="d-flex align-items-center list-action ticket-row-actions">
                      <Link
                        to={`/chat/${ticket.id_ticket}/${ticket.id_user}`}
                        className="ticket-action-button ticket-action-chat"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={translate("Detail")}
                      >
                        <i className="las la-comment-dots" style={{ fontSize: "1.2em" }} ></i>
                      </Link>
                      <span
                        onClick={() => handleOpenUpdateModal(ticket.id_ticket)} // ou autre nom d’ID
                        className="ticket-action-button ticket-action-edit"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={translate("Update")}
                        style={{ cursor: 'pointer' }}
                      >
                        <i className="las la-edit" style={{ fontSize: '1.2em' }}></i>
                      </span>

                      {/* <Link
                        to="#"
                        className="badge bg-primary mr-2"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={translate("Download")}
                        data-original-title="Download"
                        style={{ cursor: 'pointer' }}
                      >
                        <i className="las la-download" style={{ fontSize: '1.2em' }}></i>
                      </Link> */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11}>No ticket available</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="ticket-mobile-list">
        {loading ? (
          <div className="ticket-mobile-state">
            <PropagateLoader color={"#123abc"} loading={loading} size={16} />
          </div>
        ) : list_Ticket.length > 0 ? (
          list_Ticket.map((ticket) => (
            <div className="ticket-card" key={`mobile-${ticket.id_ticket}`}>
              <div className="ticket-card-header">
                <div>
                  <span className="ticket-id">#{ticket.id_ticket}</span>
                  <h6>{ticket.title}</h6>
                </div>
                <span className={getStatusClass(ticket.status)}>{translate(ticket.status.toString())}</span>
              </div>
              <p className="ticket-card-description">{ticket.description}</p>
              <div className="ticket-card-meta">
                <span><i className="las la-user"></i>{ticket.nom_user}</span>
                <span><i className="las la-calendar"></i>{formatToTimestamp(ticket.creation_date)}</span>
                <span><i className="las la-layer-group"></i>{translate(ticket.category_name)}</span>
              </div>
              <div className="ticket-card-footer">
                <div className="ticket-card-badges">
                  <span className={getPriorityClass(ticket.priority)}>{translate(ticket.priority.toString())}</span>
                  <span className={getCriticalityClass(ticket.criticality)}>{translate(ticket.criticality.toString())}</span>
                </div>
                <div className="ticket-row-actions">
                  <Link
                    to={`/chat/${ticket.id_ticket}/${ticket.id_user}`}
                    className="ticket-action-button ticket-action-chat"
                    title={translate("Detail")}
                  >
                    <i className="las la-comment-dots"></i>
                  </Link>
                  <button
                    type="button"
                    onClick={() => handleOpenUpdateModal(ticket.id_ticket)}
                    className="ticket-action-button ticket-action-edit"
                    title={translate("Update")}
                  >
                    <i className="las la-edit"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="ticket-mobile-state">No ticket available</div>
        )}
      </div>
      <div className="row ticketing-pagination">
        <div className="col-md-6 d-flex align-items-center">
          <span>
            {translate("Displaying")} {list_Ticket.length} {translate("out")}{" "}
            {total}
          </span>
        </div>
        <div className="col-md-6">
          <ReactPaginate
            previousLabel={translate("previous")}
            nextLabel={translate("next")}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-content-end"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </div>
      </div>
      <CreateTicketModal
        show={showCreateTicketModal}
        onHide={handleCloseCreateTicketModal}
        refreshTickets={refreshTickets}
        id_ticket={idTicket}
      />
      <UpdateTicketModal
        show={showUpdateTicketModal}
        onHide={handleCloseUpdateTicketModal}
        refreshTickets={refreshTickets}
        id_ticket={idTicketToUpdate}
      />

    </>
  );
}
